import './instrument'; // DOIT être le premier import - initialise Sentry avant tout
import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './index.css';
import './App.css';

import thunk from 'redux-thunk';
import promise from "redux-promise-middleware";

import { Provider } from 'react-redux'
import { applyMiddleware, createStore, compose } from 'redux';
import { rootReducer, initialState } from './store/reducers/rootReducer';

import setAuthToken from './utils/setAuthToken';
import { setCurrentUser, setCurrentEmployee } from './store/actions/authAction';
import jwt from 'jsonwebtoken';

const store = createStore(
    rootReducer,
    initialState,
    compose(
      applyMiddleware(promise(), thunk),
      // Redux enhancer disabled for performance - intercepts all Redux actions
      // Sentry.createReduxEnhancer({ ... }),
      window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f =>f,
    )
);

let user = jwt.decode(localStorage.jwtToken_compta);
if(localStorage.jwtToken_compta && user){
    if (user.isEmployee){
        setAuthToken(localStorage.jwtToken_compta, user.id, "EMPLOYEE")
        store.dispatch(setCurrentEmployee(user))
    } else {
        setAuthToken(localStorage.jwtToken_compta, user.id, "USER")
        store.dispatch(setCurrentUser(user))
    }
    // Link Sentry events to authenticated user
    if (user.id || user.user_id) {
        Sentry.setUser({
            id: String(user.id || user.user_id),
            email: user.email || user.user_email || undefined,
        });
    }
}

ReactDOM.render(
    <Sentry.ErrorBoundary fallback={({ error, resetError }) => (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <h2>Une erreur s'est produite</h2>
            <p>{error.message}</p>
            <button onClick={resetError}>Réessayer</button>
        </div>
    )}>
        <Provider store={store} >
            <App />
        </Provider>
    </Sentry.ErrorBoundary>
    , 
    document.getElementById('root')
);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
